import { useState, useMemo } from "react";
import { Calendar } from "../ui/calendar";
import { BookingCard } from "./BookingCard";
import { getApptDate, sameDay } from "../../lib/apptDate";
import { CalendarDays } from "lucide-react";

export const CalendarView = ({ items, onConfirm, onSetStatus, onDelete, onRemoveReview }) => {
  const [selectedDay, setSelectedDay] = useState(new Date());

  const datedItems = useMemo(
    () => items.map((a) => ({ a, date: getApptDate(a) })).filter((x) => x.date),
    [items]
  );

  const bookedDays = useMemo(() => datedItems.map((x) => x.date), [datedItems]);

  const dayItems = datedItems
    .filter((x) => sameDay(x.date, selectedDay))
    .map((x) => x.a);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8" data-testid="calendar-view">
      <div className="lg:col-span-5">
        <div className="bg-sand-dark rounded-3xl p-4 md:p-6 border border-charcoal/5 inline-block">
          <Calendar
            mode="single"
            selected={selectedDay}
            onSelect={(d) => d && setSelectedDay(d)}
            modifiers={{ booked: bookedDays }}
            modifiersClassNames={{ booked: "day-has-appt" }}
          />
          <div className="flex items-center gap-2 text-xs text-stone mt-3 px-2">
            <span className="inline-block w-2 h-2 rounded-full bg-clay" /> days with appointments
          </div>
        </div>
      </div>

      <div className="lg:col-span-7">
        <h3 className="font-heading text-2xl text-charcoal mb-4 flex items-center gap-2">
          <CalendarDays size={20} strokeWidth={1.5} className="text-clay" />
          {selectedDay.toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" })}
        </h3>
        {dayItems.length === 0 ? (
          <div className="bg-sand-dark rounded-3xl p-10 border border-charcoal/5 text-center text-stone" data-testid="calendar-day-empty">
            No appointments on this day.
          </div>
        ) : (
          <div className="space-y-5" data-testid="calendar-day-list">
            {dayItems.map((a) => (
              <BookingCard key={a.id} a={a} onConfirm={onConfirm} onSetStatus={onSetStatus} onDelete={onDelete} onRemoveReview={onRemoveReview} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
